export default "__VITE_ASSET__BBXGHCng__"